@if (message) {
    <p>{{ message }}</p>
}
<div class="input-dialogue-field">
    @if (label) {
        <label class="form-label">{{ label }}</label>
    }
    <input
        type="text"
        class="form-control"
        [placeholder]="placeholder"
        [(ngModel)]="value"
        autofocus
    />
</div>
